import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

export type IgnoreModalProps = {
    id: string;
    show: boolean;
    onConfirm: (id: string, notify: boolean, details: string) => void;
    onCancel: () => void;
};

export default function IgnoreModal({
    id,
    show,
    onConfirm,
    onCancel,
}: IgnoreModalProps) {
    const [notify, setNotify] = useState(false);
    const [details, setDetails] = useState("");

    const onSave = () => {
        onConfirm(id, notify, details);
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Ignore Service
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mt-1">
                    <h4>Reason:</h4>
                    <textarea
                        className="form-control"
                        rows={10}
                        onChange={(e) => setDetails(e.currentTarget.value)}
                    />
                </div>
                <div className="mt-1">
                    <h4>Notify Original Attorney</h4>
                    <div>
                        <div>
                            <label>No</label>
                            &nbsp;
                            <input
                                type="radio"
                                value="0"
                                onChange={(e) =>
                                    setNotify(e.currentTarget.value == "1")
                                }
                            />
                        </div>
                        <div>
                            <label>Yes</label>
                            &nbsp;
                            <input
                                type="radio"
                                value="1"
                                onChange={(e) =>
                                    setNotify(e.currentTarget.value == "1")
                                }
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onSave}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
}
